import { render, staticRenderFns } from "./reimbursementToOrg.vue?vue&type=template&id=060d23a3&scoped=true"
import script from "./reimbursementToOrg.vue?vue&type=script&lang=ts"
export * from "./reimbursementToOrg.vue?vue&type=script&lang=ts"
import style0 from "./reimbursementToOrg.vue?vue&type=style&index=0&id=060d23a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d23a3",
  null
  
)

export default component.exports